export default "__VITE_ASSET__CiUQjcLe__"